module.exports = __webpack_public_path__ + "img/golden.476d368d.png";